export default __webpack_public_path__ + "fonts/4d13a292f259ec4be5d853619a2f2a023507d90c672d40a0cc0b05f6663f60cb.ttf";